import Loading from "components/Loading";
import React, { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  textSize?: string;
  isLoading?: boolean;
}

export const LinearButton = React.forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, "ref">
>(({ text, textSize, className, isLoading, ...props }, ref) => (
  <button
    className={`px-4 py-3 w-full flex items-center justify-center rounded-md text-white text-center font-comfortaa ${
      textSize ? `text-[${textSize}px]` : "text-xl"
    } max-md:text-base! font-bold ${
      !props.disabled
        ? "bg-azulfy-blue bg-linear-to-t from-azulfy-blue to-azulfy-blue-hover hover:opacity-80"
        : "bg-grey-400"
    } ${className || ""}`}
    {...props}
    ref={ref}
  >
    {isLoading ? (
      <Loading hasParent={false} loadingClassName="!size-8" />
    ) : (
      text
    )}
  </button>
));
